import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  background: ${theme.colors.SurfaceRaisinBlack50};

  max-width: 355px;
  width: 100%;
  border-radius: ${({ theme }) => theme.radii.panel};
  gap: 20px;

  padding: 20px 11px;
`;

export const LinksTitle = styled.h2`
  font-family: 'SF Pro Text', serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
`;

export const LinksCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export const LinkCardText = styled.p`
  font-family: 'SF Pro Text', serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  color: #c7c7c7;
`;

export const LinkCard = styled.div`
  display: flex;
  padding: 9px;
  gap: 14px;

  justify-content: center;
  align-items: center;

  border: 1px solid ${({ theme }) => theme.colors.Gray};
  max-width: 163px;
  width: 100%;
  border-radius: ${({ theme }) => theme.radii.card};
`;
